import { inject, Injectable } from '@angular/core';
import { AbService } from '@df/module-ab/ab.service';
import { BasketService } from '@df/session/api/basket/basket.service';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { BASKET_INTERACTION_EXPERIMENT_ID } from 'projects/app-default/src/app/basket/notification-bar/basket-notification-bar.component';

export interface IMinibasketModalData {
    autoOpened?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MinibasketInitiatorService extends AbstractDfModalInitiatorService<IMinibasketModalData> {
    private abService = inject(AbService);
    private basketService = inject(BasketService);

    listen(cb: (D: IMinibasketModalData) => void): Promise<void> {
        return new Promise(resolve => {
            this.basketService.subscribeToAddToBasketSuccess(eventData => {
                if (!eventData.response?.preventMinibasketOpen && this.abService.getVariant(BASKET_INTERACTION_EXPERIMENT_ID) !== 'B') {
                    cb({
                        autoOpened: true
                    });
                }
            });
            resolve();
        });
    }
}
